import tw, { css, styled } from "twin.macro";

import type { ITypographyStyledCommon } from "@/types/common";

export const StyledWrapperDiplay = styled.h1<Omit<ITypographyStyledCommon, "$sizeVariant">>`
  ${tw`font-display text-[2.25rem] leading-[2.277rem] tracking-[0.0225rem] font-semibold text-neutral-10 transition-all ease-in-out duration-300
    medium:(text-[2.625rem] leading-[2.6565rem] tracking-[0.0525rem])
    large:(text-[3rem] leading-[3.036rem] tracking-[0.06rem])
  `}

  & > * {
    ${tw`font-display leading-[inherit] [font-weight: inherit]`};
  }

  ${({ $size }) => {
    if ($size === "small") {
      return tw`!(text-[1.5rem] tracking-[0.0225rem] leading-[2.277rem])`;
    }
    if ($size === "medium") {
      return tw`!(text-[2.625rem] leading-[2.6565rem] tracking-[0.0525rem])`;
    }
    if ($size === "large") {
      return tw`!(text-[3rem] leading-[3.036rem] tracking-[0.06rem])`;
    }
  }}

  ${({ $color }) => {
    if ($color) {
      return css`
        color: ${$color};
      `;
    }
  }};
`;
